/* eslint ember/no-new-mixins:"off" */
import { computed } from '@ember/object';
import Mixin from '@ember/object/mixin';

// `ActiveClassSupport` is a mixin that can be included in any component
// class to automatically add the classNameBinding from `isActive` to the
// `activeClass` which defaults to `is-active`.
//
// Example:
//
// ```js
// const SimpleDivComponent = Ember.Component.extend(ActiveClassSupport);
//
// const GaudySectionComponent = Ember.Component.extend(ActiveClassSupport, {
//   tagName: 'section',
//   activeClass: 'rainbows-and-lightning-making-love'
// });
// ```
//
// ```handlebars
// {{simple-div isActive=hatersAreHating}}
// {{gaudy-section isActive=true}}
// ```
//
// ```html
// <div class="is-active"></div> <!-- when hatersAreHating is true -->
// <section class="rainbows-and-lightning-making-love"></section> <!-- when isActive is true -->
// ```

export default Mixin.create({
  activeClass: 'is-active',
  classNameBindings: ['_isActive'],
  _isActive: computed('activeClass', 'isActive', function () {
    if (this.isActive) {
      return this.activeClass;
    }
    return undefined;
  })
});